import React, {useEffect} from 'react';
import {UeThemeProvider} from 'epic-ue-theme';
import {ClassicGlobalStyle} from './components/global/ClassicGlobalStyle';
import {FooterWrapper} from './components/footer/Footer';
import {ueLightTheme} from 'epic-ue-theme';
import {useLocation} from 'react-router-dom';
import root from 'window-or-global';
import {createSharedValueKey, useSharedValue} from '@epic-core/hooks';
import queryString from 'query-string';
import {withLocalization, LocalizationProps} from '@epic-mw/localization';
import {isClassicRoute} from './routes/routes';
import {useRoutesElement} from './routes/routes';
import CmsPage from './CmsPage';
import {GlobalNavWrapper} from './components/nav/GlobalNavWrapper';

interface Properties {
    supportedLocales: Array<{name: string; lang: string}>;
    locale: string;
    cmsPage: boolean;
}

export const modeKey = createSharedValueKey<string | string[]>('modeKey', '');

const AppInner = ({cmsPage}: Properties & LocalizationProps): JSX.Element => {
    const clientEnvConfig = root.clientEnvConfig || {};
    const epicEnv = clientEnvConfig.EPIC_ENV;
    const isProd = epicEnv === 'prod' || epicEnv === 'production';
    const routes = useRoutesElement();
    const location = useLocation();
    const query = queryString.parse(location.search) || {};
    const queryMode = query.mode || '';
    const [mode, setMode] = useSharedValue(modeKey);

    useEffect(() => {
        if (queryMode && mode !== queryMode) {
            setMode(queryMode);
        }
    }, [setMode, mode, queryMode]);

    const hideHeaderFooter = queryMode;
    const classic = isClassicRoute(location.pathname);

    const legacyClass = classic ? 'bootstrap-custom' : '';

    return (
        <UeThemeProvider theme={ueLightTheme}>
            {classic ? <ClassicGlobalStyle /> : ''}
            {!isProd && <div className="environment" title={epicEnv} />}
            {!hideHeaderFooter ? <GlobalNavWrapper /> : ''}
            <div className={legacyClass}>
                <div className="eg-app ue-react">
                    <div className="eg-content">{cmsPage ? <CmsPage /> : routes}</div>
                </div>
            </div>
            {!hideHeaderFooter ? <FooterWrapper /> : ''}
        </UeThemeProvider>
    );
};

export const App = withLocalization(AppInner);
